import { memo, ReactElement } from 'react';
import AccordionRequestAssessment from './accept-messi';
import AccordionPracticeNotAvailable from './practice-not-available';
import StepFamily from './step-family';
import StepDocument from './step-document';
import StepResidence from './step-residence';
import StepRegisterOffice from './step-register-office';
import StepRecap from './recap';
import AccordionExceptionList from './accordion-exception-list';
import AccordionAnnullament from './step-annulment';
import { TypeRegister } from 'practice/constants/type-register';
import StepResidenceUnavailablity from './step-residence-unavailability';
import { RegisterOfficeVM } from 'shell/view-models/register-office-practice-vm';
import { EccezioneVOList } from 'shell/models/practice';
import { PracticeDraftStep, TypeInitiative } from 'practice/constants/practice-management-step';

interface ActiveStepProps {
  step?: number;
  identifierAnpr: string;
  onBack: (step?: PracticeDraftStep) => void;
  onNext: (step?: PracticeDraftStep) => void;
  typeRegister: string;
  yearId: string;
  progressive: string;
  idFamilyAnpr?: string;
  codeEnte?: string;
  typePractice?: string;
  intestatarioIsAnpr?: boolean;
  setIntestatarioIsAnpr: (value: boolean) => void;
  setTipoIniziativa: (value?: TypeInitiative) => void;
  iniziativa?: TypeInitiative;
  setStepBozza: (value: number) => void;
  stepBozza?: number;
  setCodOperatorePratica: (value: string) => void;
  codOperatorePratica?: string;
  eccezioni: EccezioneVOList;
  setDisabledAll: (value: boolean) => void;
  disabledAll?: boolean;
  ForPracticeTemporary?: boolean;
  maxActiveStep?: number;
  setIsAcceptMessi: (value: boolean) => void;
  setIsDisabledCancel: (value: boolean) => void;
  setStatoPratica: (value: string) => void;
  fromPerson?: TypeInitiative;
  setFromPerson: (value?: TypeInitiative) => void;
  stepRegisterOfficeState?: RegisterOfficeVM;
  setStepRegisterOfficeState: (values: RegisterOfficeVM) => void;
}

const ActiveStepComponent = ({
  step,
  typeRegister,
  yearId,
  progressive,
  codeEnte,
  typePractice,
  idFamilyAnpr,
  intestatarioIsAnpr,
  setIntestatarioIsAnpr,
  setTipoIniziativa,
  iniziativa,
  setStepBozza,
  ForPracticeTemporary,
  stepBozza = 0,
  identifierAnpr,
  setCodOperatorePratica,
  codOperatorePratica,
  eccezioni,
  setDisabledAll,
  disabledAll,
  onBack,
  onNext,
  maxActiveStep = 0,
  setIsAcceptMessi,
  setIsDisabledCancel,
  setStatoPratica,
  fromPerson,
  setFromPerson,
  setStepRegisterOfficeState,
  stepRegisterOfficeState,
}: ActiveStepProps): ReactElement => {
  switch (step) {
    case PracticeDraftStep.RegisterOffice:
      return (
        <StepRegisterOffice
          codeEnte={codeEnte}
          yearId={yearId}
          typeRegister={typeRegister}
          progressive={progressive}
          typePractice={typePractice}
          idFamily={idFamilyAnpr}
          intestatarioIsAnpr={intestatarioIsAnpr}
          setIntestatarioIsAnpr={setIntestatarioIsAnpr}
          setTipoIniziativa={setTipoIniziativa}
          setStepBozza={setStepBozza}
          setDisabledAll={setDisabledAll}
          stepBozza={stepBozza}
          iniziativa={iniziativa}
          setCodOperatorePratica={setCodOperatorePratica}
          codOperatorePratica={codOperatorePratica}
          onNext={onNext}
          maxActiveStep={maxActiveStep}
          disabledAll={disabledAll}
          setIsDisabledCancel={setIsDisabledCancel}
          ForPracticeTemporary={ForPracticeTemporary}
          setStatoPratica={setStatoPratica}
          setFromPerson={setFromPerson}
          setStepRegisterOfficeState={setStepRegisterOfficeState}
        />
      );
    case PracticeDraftStep.Family:
      return (
        <StepFamily
          ForPracticeTemporary={ForPracticeTemporary}
          codeEnte={codeEnte}
          yearId={yearId}
          typeRegister={typeRegister}
          progressive={progressive}
          typePractice={typePractice}
          idFamily={idFamilyAnpr}
          codOperatorePratica={codOperatorePratica}
          onBack={onBack}
          onNext={onNext}
          maxActiveStep={maxActiveStep}
          disabledAll={disabledAll}
          iniziativa={iniziativa}
          stepRegisterOfficeState={stepRegisterOfficeState}
        />
      );
    case PracticeDraftStep.Residence:
      return typeRegister === TypeRegister.Unavailable ||
        typeRegister === TypeRegister.UntraceableCensus ? (
        <>
          <StepResidenceUnavailablity
            idFamilyAnpr={idFamilyAnpr}
            onBack={onBack}
            onNext={onNext}
            typePractice={typePractice}
            codeEnte={codeEnte}
            iniziativa={iniziativa}
            yearId={yearId}
            typeRegister={typeRegister}
            progressive={progressive}
            maxActiveStep={maxActiveStep}
            disabledAll={disabledAll}
            ForPracticeTemporary={ForPracticeTemporary}
            intestatarioIsAnpr={intestatarioIsAnpr}
            fromPerson={fromPerson}
          />
        </>
      ) : (
        <StepResidence
          idFamilyAnpr={idFamilyAnpr}
          onBack={onBack}
          onNext={onNext}
          typePractice={typePractice}
          codeEnte={codeEnte}
          iniziativa={iniziativa}
          yearId={yearId}
          typeRegister={typeRegister}
          progressive={progressive}
          maxActiveStep={maxActiveStep}
          disabledAll={disabledAll}
          ForPracticeTemporary={ForPracticeTemporary}
          intestatarioIsAnpr={intestatarioIsAnpr}
          fromPerson={fromPerson}
        />
      );
    case PracticeDraftStep.Documents:
      return (
        <StepDocument
          onBack={onBack}
          onNext={onNext}
          codeEnte={codeEnte}
          yearId={yearId}
          typeRegister={typeRegister}
          progressive={progressive}
          codOperatorePratica={codOperatorePratica}
          maxActiveStep={maxActiveStep}
          ForPracticeTemporary={ForPracticeTemporary}
          disabledAll={disabledAll}
          iniziativa={iniziativa}
        />
      );
    case PracticeDraftStep.Irricevibilita:
      return (
        <AccordionPracticeNotAvailable
          onNext={onNext}
          codeEnte={codeEnte}
          yearId={yearId}
          typeRegister={typeRegister}
          progressive={progressive}
          maxActiveStep={maxActiveStep}
          disabledAll={disabledAll}
          iniziativa={iniziativa}
        />
      );
    case PracticeDraftStep.Recap:
      return (
        <StepRecap
          codeEnte={codeEnte}
          yearId={yearId}
          typeRegister={typeRegister}
          progressive={progressive}
          typePractice={typePractice}
          identifierAnpr={identifierAnpr}
          onBack={onBack}
          ForPracticeTemporary={ForPracticeTemporary}
          onNext={onNext}
          disabledAll={disabledAll}
          iniziativa={iniziativa}
          fromPerson={fromPerson}
          setIsAcceptMessi={setIsAcceptMessi}
        />
      );
    case PracticeDraftStep.AccertamentoMessi:
      return (
        <AccordionRequestAssessment
          codeEnte={codeEnte}
          yearId={yearId}
          typeRegister={typeRegister}
          progressive={progressive}
          typePractice={typePractice}
          setDisabledAll={setDisabledAll}
          disabledAll={disabledAll}
          iniziativa={iniziativa}
          onNext={onNext}
          onBack={onBack}
          setIsAcceptMessi={setIsAcceptMessi}
        />
      );
    case PracticeDraftStep.ExceptionList:
      return <AccordionExceptionList eccezioni={eccezioni} />;
    case PracticeDraftStep.Annullament:
      return (
        <AccordionAnnullament
          codeEnte={codeEnte}
          yearId={yearId}
          typeRegister={typeRegister}
          progressive={progressive}
        />
      );
    default:
      return <></>;
  }
};

ActiveStepComponent.displayName = 'Active step component';

const ActiveStep = memo(ActiveStepComponent) as typeof ActiveStepComponent;

export default ActiveStep;
